import React from "react";

const Doctor = () => {
  return (
    <div className="mt-10">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-4 py-12">
        <div className="text-center pb-12">
          <h1 className="font-bold title-design text-3xl md:text-4xl lg:text-5xl font-heading text-gray-900">
            Check our awesome doctors
          </h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="w-full bg-white rounded-lg lg:p-12 flex flex-col justify-center items-center">
            <div className="mb-8">
              <img
                className="object-center object-cover rounded-full h-36 w-36"
                src="https://images.pexels.com/photos/6303591/pexels-photo-6303591.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt=""
              />
            </div>
            <div className="text-center">
              <p className="text-xl text-gray-700 font-bold mb-2">
                Hasan Masud
              </p>
              <p className="text-base text-gray-400 font-normal">
                Doctor(Surgery Specialist)
              </p>
            </div>
          </div>
          <div className="w-full bg-white rounded-lg lg:p-12 flex flex-col justify-center items-center">
            <div className="mb-8">
              <img
                className="object-center object-cover rounded-full h-36 w-36"
                src="https://images.pexels.com/photos/8376181/pexels-photo-8376181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="doctor"
              />
            </div>
            <div className="text-center">
              <p className="text-xl text-gray-700 font-bold mb-2">
                Karim Khalil
              </p>
              <p className="text-base text-gray-400 font-normal">
                Doctor(Eye Specialist)
              </p>
            </div>
          </div>
          <div className="w-full bg-white rounded-lg lg:p-12 flex flex-col justify-center items-center">
            <div className="mb-8">
              <img
                className="object-center object-cover rounded-full h-36 w-36"
                src="https://images.pexels.com/photos/7089019/pexels-photo-7089019.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="doctor"
              />
            </div>
            <div className="text-center">
              <p className="text-xl text-gray-700 font-bold mb-2">
                Akramuzzana Asif
              </p>
              <p className="text-base text-gray-400 font-normal">
                Doctor(Kidney Specialist)
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Doctor;
